<template lang="pug">
	
	.engagement-intro

		section-intro(img="assets/images/joey-concert.jpg" :title="translate('engagement.title')" fade=0)

		.story-wrapper
			story-text.text-1
				p(slot="text-content" v-html="translate('engagement.text_1')").text
			
			story-text.text-2
				p(slot="text-content" v-html="translate('engagement.text_2')").text
			
			quote.quote-1
				blockquote(slot="quote" v-html="translate('engagement.quote_1')")
				p(slot="translation" v-html="translate('engagement.translation_1')").translation
			
			
			quote.quote-2
				blockquote(slot="quote" v-html="translate('engagement.quote_2')") 
			
			story-text.text-3
				p(slot="text-content" v-html="translate('engagement.sentence')").text
			

</template>

<script>
		
	import Vue from 'vue'
	import Component from 'vue-class-component'
	import $ from 'jquery'
	import { TweenMax } from 'gsap'
	import Scrollable from '~abstracts/scrollable'
	import SectionIntro from '~components/section-intro.vue'
	import SplitedText from '~components/splited-text.vue'
	import Quote from '~components/content-elements/quote.vue'
	import StoryText from '~components/content-elements/story-text.vue'
	
  	@Component({
		name: 'PoliticalIntro',
		components: { SectionIntro,SplitedText,StoryText,Quote }
	})

	class PoliticalIntro extends Scrollable {

		mounted () {
			super.mounted()

			

			this._dom()
		}

		init () {
			super.init()

		}


		_dom () {
			
			this.$text = this.$el.querySelector('.text')
			this.$fakeText = this.$el.querySelector('.fake-text')

		}

		_intervals () {
			
			this.scroller.point('text.in',{
				position: this.bounds.top + window.innerHeight * .3,
				direction: 1,
				exec: (e)=>{
					if(e.direction == 1 ) {
						// this.$refs.splitedText.tlAppear.play(0)
					} else {
						// this.$refs.splitedText.tlAppear.reverse(0)
					}
				}
			})

		}

		_bind () {
			super._bind()
		}


		_resize () {
			super._resize()

			this._intervals()
		}

		_on () {
			super._on()
		}

		_off () {
			super._off()
		}

	}

	export default PoliticalIntro

</script>


<style lang="stylus">
	
	@import '../../../theme/utils'
	@import '../../../theme/variables'
	
	.engagement-intro
		width 100%
		// padding-top calc(50vh + 225px)
		position relative

		.section-intro
			.title
				max-width 1000px
				margin auto

		.story-wrapper
			position relative
			z-index 50
			text-align center
			margin-top 100px

			.story-text
				margin auto
				max-width 580px

			.quote
				margin auto
				max-width 830px

			.quote-1
				margin-top 50px

			.quote-2
				margin-top 50px

			.text-3
				margin-top 50px
		

</style>


// WEBPACK FOOTER //
// engagement-intro.vue?7155a561